module.exports = __webpack_public_path__ + "static/the-orbweavers-logo-c102380534d2826a26617bf6a3c7f39c.png";